export function simpleHash(str) {
  let hash = 0
  let chr

  if (str.length === 0) {
    return hash
  }
  for (let i = 0; i < str.length; i++) {
    chr   = str.charCodeAt(i)
    hash  = ((hash << 5) - hash) + chr
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}

/**
 * Generates a key consisting of the request url and unique hash based on the userUid and request parameters
 * @param {string} url : request url
 * @param {object} params : request params
 * @param {string} cacheIdentifier: identifier to append to the cache key name
 * @returns {string} : Example: 'ccp/userData/getUserPictures:-614443294'
 */
export const generateCacheKey = baseUrl => (endpoint, params, cacheIdentifier) => {
  return `${baseUrl}${endpoint}`.replace(/(^\w+:|^)\/\//, '')
    + ':'
    + simpleHash(`${cacheIdentifier}${JSON.stringify(params || {})}`)
}

export const isRequired = param => {
  throw new Error(`"${param}" is required`)
}

export const requiredParams = (params, requiredParamsArg) => {
  const missingParams = []
  for (let param of requiredParamsArg) {
    if (!params[param]) {
      missingParams.push(param)
    }
  }

  if (missingParams.length) {
    throw new Error(`Missing parameters in ccp-provider: ${missingParams.join(', ')}`)
  }
}
